import {
  USER_Delete_CART_ITEMS_LOADING,
  USER_Delete_CART_ITEMS_SUCCESS,
  USER_Delete_CART_ITEMS_FAILURE,
} from "redux/types";

const initialState = {
  deleteItemLoading: false,
  deleteItem: null,
  errros: null,
};

export const userDeleteCartItem = (state = initialState, action: any) => {
  switch (action.type) {
    case USER_Delete_CART_ITEMS_LOADING:
      return { ...state, deleteItemLoading: action.payload };
    case USER_Delete_CART_ITEMS_SUCCESS:
      return { ...state, deleteItem: action.payload };
    case USER_Delete_CART_ITEMS_FAILURE:
      return { ...state, errros: action.payload };
    default:
      return state;
  }
};
